import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export interface InsertAppleIAPPayload {
  formData: FormData;
}

interface InsertAppleIAPResponse {
  message?: string;
  social_account_id?: number | string;
}

export const useInsertAppleIAP = () => {
  const queryClient = useQueryClient();

  return useMutation<InsertAppleIAPResponse, Error, InsertAppleIAPPayload>({
    mutationFn: async ({formData }) => {
      // Attach tracking id as query param similar to other endpoints
      return httpService.post<InsertAppleIAPResponse, FormData>(
        API_CONFIG.path.appleAdsAccounts,
        formData,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["integrations"] });
    },
  });
};
